/**
 * DateDivider - Reusable date divider component
 * Displays a date with horizontal lines on both sides
 * Used to group content by date in lists
 */
function DateDivider({ date }) {
  // Format date for display (e.g., "May 30, 2026" or "Today")
  const formatDate = (dateStr) => {
    const date = new Date(dateStr + 'T00:00');
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Check if the date is today
    const inputDate = new Date(dateStr + 'T00:00');
    inputDate.setHours(0, 0, 0, 0);

    if (inputDate.getTime() === today.getTime()) {
      return 'Today';
    }

    return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  };

  return (
    <div className="mb-3 flex items-center gap-2">
      <div className="flex-1 h-px bg-border" />
      <span className="text-xs font-semibold uppercase text-muted-foreground">
        {formatDate(date)}
      </span>
      <div className="flex-1 h-px bg-border" />
    </div>
  );
}

export default DateDivider;
